export const link =
  'border-none hover:underline text-foreground font-semibold underline underline-offset-[3px] whitespace-nowrap';

export const ghost =
  'bg-transparent text-foreground hover:bg-foreground/[0.04] active:bg-foreground/[0.065] focus-visible:bg-foreground/[0.04]';
